// reducers/caseDetailsReducer.js
import { CASE_DETAILS, CASE_DETAILS_TEMP, FULL_CASE_DETAILS } from "./actions";

const initialState = {};

const caseDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case CASE_DETAILS: {
            return { ...state, ...action.payload, Id: Math.random() };
        }
        case FULL_CASE_DETAILS: {
            // Replace state entirely with new payload
            return { ...action.payload };
        }
        case CASE_DETAILS_TEMP: {
            // NOSONAR
            return { ...state, Id: Math.random() };
        }
        default:
            return state;
    }
};

export default caseDetailsReducer;
